import { format } from 'date-fns'
import type { FrontendLog } from '@/types/frontendLog'

export interface ScenarioLike {
  id: string
  name?: string | null
}

// ユーザーが付けたタイトルを最優先で表示する。タイトル未設定時の自動名
// （プレイバックシナリオN）はタイトル扱いせず、ID パターン (scenario-{timestamp})
// から作成日時ラベルにフォールバックする。
export function getScenarioLabel(scenario: ScenarioLike): string {
  const name = scenario.name?.trim()
  if (name && !/^プレイバックシナリオ\d+$/.test(name)) {
    return name
  }
  const match = scenario.id.match(/^scenario-(\d+)$/)
  if (match) {
    return `プレイバック（${format(new Date(Number(match[1])), 'yyyy-MM-dd HH:mm')}）`
  }
  return name || scenario.id
}

const SCENARIO_LABEL_ACTIONS = new Set([
  'scenario_selected',
  'scenario_execute',
  'scenario_complete',
])

export function getScenarioLabelFromLog(log: FrontendLog): string | null {
  if (!SCENARIO_LABEL_ACTIONS.has(log.action)) return null
  const scenarioId = log.context?.scenarioId
  if (typeof scenarioId !== 'string' || scenarioId.length === 0) return null
  const scenarioName = log.context?.scenarioName
  return getScenarioLabel({
    id: scenarioId,
    name: typeof scenarioName === 'string' ? scenarioName : null,
  })
}

// シナリオ実行開始ログの executionMode を日本語ラベルに変換する。
// initialize はデフォルト動作のため null を返し、明示的に意味のあるモードだけを表示する。
export function getExecutionModeLabelFromLog(log: FrontendLog): string | null {
  if (log.action !== 'scenario_execute') return null
  const mode = log.context?.executionMode
  if (mode === 'continue') return '続きから実行'
  if (mode === 'from_slot') return '開始スロットを指定して実行'
  return null
}
